import axios from "axios";

var UserLabel = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (params) {
        return axios.get(
            Apollo.resolveApiUrl("~/userlabel"),
            {
                params: params
            });
    },
    post: function (label) {
        return axios.post(
            Apollo.resolveApiUrl("~/userlabel"),
            label
        );
    },
    put: function (label) {
        return axios.put(
            Apollo.resolveApiUrl("~/userlabel/") + label.Id,
            label
        );
    },
    delete: function (label) {
        return axios.delete(
            Apollo.resolveApiUrl("~/userlabel/") + label.Id
        );
    }
};

export default UserLabel;



// WEBPACK FOOTER //
// ./src/models/UserLabel.js